import loadable from '@loadable/component'

export default [
  {
    path: '/voteMachine',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-voteMachine-index" */ '~/pages/voteMachine/pages/index'
        )
    ),
  },
  {
    path: '/voteMachine/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-voteMachine-record" */ '~/pages/voteMachine/pages/record'
        )
    ),
  },
  {
    path: '/voteMachine/record/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-voteMachine-RecordDetail" */ '~/pages/voteMachine/pages/RecordDetail'
        )
    ),
  },
  {
    path: '/voteMachine/rule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-voteMachine-rule" */ '~/pages/voteMachine/pages/rule'
        )
    ),
  },
]
